
import React, { useState } from 'react'
import { Form } from 'react-bootstrap'
import { useDispatch } from 'react-redux'

import useTranslation from '../../../Hooks/UseTranslation'
import { updateGroupNameAction } from '../../../Redux/Actions/ProgrammationManagerActions'

import InputText from '../components/InputText'
import { useProgrammation } from '../../../Hooks/UseProgrammation'
import { updateGroupName } from '@/Services/ProgrammationManagerService'
import { useProject } from '@/Hooks/UseProject'

const GroupName = () => {

  const dispatch = useDispatch()

  const { t } = useTranslation()

  const { project_id } = useProject()

  const { itemOpened, setEditingItem, patchItemOpened, errors, setError, unSetError } = useProgrammation()

  const [ name, setName ] = useState(itemOpened.name)

  const handleChangeName = async () => {

    setEditingItem(true)

    unSetError('name')

    const [error] = await updateGroupName(itemOpened._id, name, project_id);

    setEditingItem(false)

    if (error) {

      setError({
        field: 'name',
        error: 'ocurrió un error al actualizar el nombre',
      })

      console.log('error', error)

      return false;
    }

    patchItemOpened({
      name,
    })

    await dispatch(updateGroupNameAction(itemOpened._id, name, project_id))

    setEditingItem(false)
  }

  return (
    <Form.Group>
      <Form.Label>
        {t('PROGRAMMATION_MANAGER:NameLabel')}
      </Form.Label>
      <InputText
        value={name}
        onChange={setName}
        // onStartEditing={() => setEditingItem(true)}
        placeholder="Ingresa el nombre"
        onBlur={handleChangeName}
        delay={500}
        error={errors.find((error: any) => error.field === 'name')}
      />
    </Form.Group>
  )
}

export default GroupName
